import * as products_select from "../products/products.scenarios.select.svelte.js";
import {booking} from "./feature.booking.svelte.js";
import {BUYABLE_TYPE_NON_PACKAGEDEAL, BUYABLE_TYPE_PACKAGEDEAL, ENTRY_DURATION_2_HOUR, ENTRY_DURATION_EVENING} from "../../AppConstants";
import * as booking_actions from "./actions_booking.svelte.js";
import * as booking_select from "./booking.scenarios.select.svelte.js";
import * as booking_select_datetime from "./booking.scenarios.select.datetime.svelte.js"; // referentie naar self
import AppConfig from "../../AppConfig";
import DateTimeUtil from "../../utils/DateTimeUtil";
import {progress} from "../progress/feature.progress.svelte.js";

export function getAvailableArrivalTimes(bGroupPerHour = false)
{
  let aAvailableArrivalTimes = DateTimeUtil.getTimeObjectsFromTo(booking.iFirstPossibleArrivalTime, booking.iLastPossibleArrivalTime);

  let aCalendarConfigHoursDataForSelectedDate = [];
  let iNrOfPeople = booking.lPeople.length;

  let iArrivalYear = parseInt(booking.sArrivalYear);
  let iArrivalMonth = parseInt(booking.sArrivalMonth);
  let iArrivalDay = parseInt(booking.sArrivalDay);

  if ( typeof progress.aCalendarDates[iArrivalYear + '-' + iArrivalMonth + '-' + iArrivalDay] !== "undefined" && typeof progress.aCalendarDates[iArrivalYear + '-' + iArrivalMonth + '-' + iArrivalDay].HoursConfig !== "undefined" )
  {
    aCalendarConfigHoursDataForSelectedDate = progress.aCalendarDates[iArrivalYear + '-' + iArrivalMonth + '-' + iArrivalDay].HoursConfig;
  }

  // console.log('aCalendarConfigHoursDataForSelectedDate1', iArrivalYear + '-' + iArrivalMonth + '-' + iArrivalDay, $state.snapshot(progress.aCalendarDates));
  // console.log('aCalendarConfigHoursDataForSelectedDate 2', aCalendarConfigHoursDataForSelectedDate);
  if ( aCalendarConfigHoursDataForSelectedDate && aCalendarConfigHoursDataForSelectedDate.length > 0 )
  {
    aAvailableArrivalTimes = aAvailableArrivalTimes.map((aTimeSlotConfigToCheck) => {

      // Kijk in alle CalendarConfigHours van deze dag welke matchen bij de aankomsttijd die we nu checken
      const aCalendarConfigHourRecordsForThisArrivalTime = aCalendarConfigHoursDataForSelectedDate.filter((oCalendarConfigHour) => {
        return parseInt(oCalendarConfigHour.TimeSlotHour) === parseInt(aTimeSlotConfigToCheck.iHours)
          && parseInt(oCalendarConfigHour.TimeSlotMin) === parseInt(aTimeSlotConfigToCheck.iMinutes);
      });

      if ( aCalendarConfigHourRecordsForThisArrivalTime && aCalendarConfigHourRecordsForThisArrivalTime.length > 0 )
      {
        let bIsThisSlotAvailable = false;

        // gebruik de eerste match (normaal gesproken is er ook maar 1)
        let oCalendarConfigHour = aCalendarConfigHourRecordsForThisArrivalTime[0];
        // console.log(' oCalendarConfigHour', oCalendarConfigHour);
        switch ( iNrOfPeople )
        {
          case 1:
            bIsThisSlotAvailable = oCalendarConfigHour.AP1;
            break;
          case 2:
            bIsThisSlotAvailable = oCalendarConfigHour.AP2;
            break;
          case 3:
            bIsThisSlotAvailable = oCalendarConfigHour.AP3;
            break;
          case 4:
            bIsThisSlotAvailable = oCalendarConfigHour.AP4;
            break;
        }

        if ( bIsThisSlotAvailable !== true )
        {
          //console.log("Deze tijd is niet beschikbaar:", $state.snapshot(aTimeSlotConfigToCheck));

          aTimeSlotConfigToCheck.bAvailable = false;

          if ( parseInt(booking.iArrivalTime) === parseInt(aTimeSlotConfigToCheck.TimeSlot) )
          {
            booking_actions.setArrivalTime(0);
          }
        }
      }

      return aTimeSlotConfigToCheck;
    });
  }

  if ( bGroupPerHour !== true )
  {
    return aAvailableArrivalTimes;
  }

  // groeperen per uur
  let aNewResponse = [];

  let iHour, aHourSet;
  let iHourPrevConfig = false;
  let aHourConfig = [];

  aAvailableArrivalTimes.forEach((oTimeConfig) => {
    iHour = oTimeConfig.iHours;

    if ( iHour !== iHourPrevConfig )
    {
      if ( aHourConfig.length > 0 )
      {
        aNewResponse.push([...aHourConfig]);
        aHourConfig = [];
      }
    }

    aHourConfig.push({...oTimeConfig});
    iHourPrevConfig = iHour;
  });

  // de laatste nog toevoegen
  aNewResponse.push([...aHourConfig]);

//console.log('debug tijdconfigs', aNewResponse);
  return aNewResponse;
}

export function getAvailableDepartureTimes(bGroupPerHour = false)
{
  let aAvailableDepartureTimes = DateTimeUtil.getTimeObjectsFromTo(booking.iFirstPossibleDepartureTime, booking.iLastPossibleDepartureTime);

  if ( bGroupPerHour !== true )
  {
    return aAvailableDepartureTimes;
  }

  let aNewResponse = [];

  let iHour, aHourSet;
  let iHourPrevConfig = false;
  let aHourConfig = [];

  aAvailableDepartureTimes.forEach((oTimeConfig) => {
    iHour = oTimeConfig.iHours;

    if ( iHour !== iHourPrevConfig )
    {
      if ( aHourConfig.length > 0 )
      {
        aNewResponse.push([...aHourConfig]);
        aHourConfig = [];
      }
    }

    aHourConfig.push({...oTimeConfig});
    iHourPrevConfig = iHour;
  });

  // de laatste nog toevoegen
  aNewResponse.push([...aHourConfig]);

  return aNewResponse;
}

export function getFirstPossibleArrivalTimeBasedOnBooking()
{
  const sArrivalDate = booking.sArrivalDate;

  let bIsPackageDealBooking = booking_select.isPackageDealBooking();

  let sMainBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
  const iPackageDealID = booking_select.getPackageDealIDThatIsActuallyAddedToOrder();
  if ( iPackageDealID || bIsPackageDealBooking ) sMainBuyableType = BUYABLE_TYPE_PACKAGEDEAL;

  let oBuyable = false;
  let iEntryProductID = false;

  //window.console.log(">>>>", sArrivalDate, DateTimeUtil.getDateFromString(sArrivalDate));

  let iFirstPossibleArrivalTime = AppConfig.getIDefaultOpeningTimeSauna(
    DateTimeUtil.getDateFromString(sArrivalDate)
  );

  //console.log("avond debug 2");
  iEntryProductID = booking_select.getCurrentlySelectedActionEntry();
  if ( !iEntryProductID ) iEntryProductID = booking_select.getCurrentlySelectedNonActionEntry();

  if ( iEntryProductID )
  {
    oBuyable = products_select.getProductByID(iEntryProductID);

    //console.log("avond debug 4", $state.snapshot(oBuyable));

    if ( oBuyable )
    {
      if ( products_select.isEntryProduct(iEntryProductID) )
      {
        let sEntryType = products_select.getEntryType(iEntryProductID);

        if ( sEntryType === ENTRY_DURATION_EVENING )
        {
          iFirstPossibleArrivalTime = AppConfig.getIFirstEntryTimeEveningEntry(DateTimeUtil.getDateFromString(sArrivalDate));
        }
      }
    }
  }


  // als de datum vandaag is en het is inmiddels later dan iFirstPossibleArrivalTime, dan aanpassen
  if ( booking_select_datetime.isTodayTheCurrentlySelectedArrivalDate() === true )
  {
    const iTimeNow = DateTimeUtil.getJoinedHoursMinIntForXMinutesFromNow(0);
    // console.log('iTimeNow', iTimeNow);
    const sTimeNow = iTimeNow + '';
    const sTimeNowMinutes = sTimeNow.substring(-2);
    const iTimeNowMinutes = parseInt(sTimeNowMinutes);
    let sTimeNowMinutesCorrected = iTimeNowMinutes;

    if ( iTimeNowMinutes > 30 )
    {
      sTimeNowMinutesCorrected = '30';
    }
    else
    {
      sTimeNowMinutesCorrected = '00'
    }

    // console.log('sTimeNowMinutes', sTimeNowMinutes);
    // console.log('iTimeNowMinutes', iTimeNowMinutes);
    // console.log('sTimeNowMinutesCorrected', sTimeNowMinutesCorrected);
    // console.log('uren', sTimeNowMinutes.slice(0, -2));

    let sTimeNowRounded = sTimeNow.slice(0, -2) + sTimeNowMinutesCorrected;
    let iTimeNowRounded = parseInt(sTimeNowRounded);
// console.log('sTimeNowRounded', sTimeNowRounded);
// console.log('iTimeNowRounded', iTimeNowRounded);
    if ( iFirstPossibleArrivalTime < iTimeNowRounded )
    {   // afronden naar 30 minuten
      iFirstPossibleArrivalTime = iTimeNowRounded;
    }
  }

  return iFirstPossibleArrivalTime;
}

export function getLastPossibleArrivalTimeBasedOnBooking()
{
  const sArrivalDate = booking.sArrivalDate;

  let bIsPackageDealBooking = booking_select.isPackageDealBooking();

  let sMainBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
  const iPackageDealID = booking_select.getPackageDealIDThatIsActuallyAddedToOrder();
  if ( iPackageDealID || bIsPackageDealBooking ) sMainBuyableType = BUYABLE_TYPE_PACKAGEDEAL;

  let iLastPossibleArrivalTime = AppConfig.getIDefaultLastEntryTime(
    DateTimeUtil.getDateFromString(sArrivalDate)
  );

  if ( sMainBuyableType === BUYABLE_TYPE_NON_PACKAGEDEAL )
  {

  }
  else if ( sMainBuyableType === BUYABLE_TYPE_PACKAGEDEAL )
  {
    // op dit moment nietssss
  }

  return iLastPossibleArrivalTime;
}

export function getFirstPossibleDepartureTimeBasedOnBooking()
{
  let bIsPackageDealBooking = booking_select.isPackageDealBooking();

  let sMainBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
  const iPackageDealID = booking_select.getPackageDealIDThatIsActuallyAddedToOrder();
  if ( iPackageDealID || bIsPackageDealBooking ) sMainBuyableType = BUYABLE_TYPE_PACKAGEDEAL;

  const sArrivalDate = booking.sArrivalDate;

  let oBuyable = null;
  let iEntryProductID = null;
  let iFirstPossibleDepartureTime = AppConfig.getIDefaultOpeningTimeSauna(
    DateTimeUtil.getDateFromString(sArrivalDate)
  );

  //Voor 14:00 is het mogelijk per kwartier te boeken
  if ( iFirstPossibleDepartureTime < 1400 )
  {
    iFirstPossibleDepartureTime += 15;
  }
  else
  {
    iFirstPossibleDepartureTime += 30;
  }

  //Voor 14:00 is het mogelijk per kwartier te boeken
  if ( iFirstPossibleDepartureTime < 1400 )
  {
    iFirstPossibleDepartureTime += 15;
  }
  else
  {
    iFirstPossibleDepartureTime += 30;
  }

  iEntryProductID = booking_select.getCurrentlySelectedActionEntry() ||
    booking_select.getCurrentlySelectedNonActionEntry();

  if ( iEntryProductID )
  {
    oBuyable = products_select.getProductByID(iEntryProductID);

    if ( oBuyable && products_select.isEntryProduct(iEntryProductID) )
    {
      const sEntryType = products_select.getEntryType(iEntryProductID);

      if ( sEntryType === ENTRY_DURATION_EVENING )
      {
        iFirstPossibleDepartureTime = AppConfig.getIFirstEntryTimeEveningEntry(
          DateTimeUtil.getDateFromString(sArrivalDate)
        );

        if ( iFirstPossibleDepartureTime < 1400 )
        {
          iFirstPossibleDepartureTime += 15;
        }
        else
        {
          iFirstPossibleDepartureTime += 30;
        }
      }
    }
  }

  return iFirstPossibleDepartureTime;
}

export function getLastPossibleDepartureTimeBasedOnBooking()
{
  let bIsPackageDealBooking = booking_select.isPackageDealBooking();

  let sMainBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
  const iPackageDealID = booking_select.getPackageDealIDThatIsActuallyAddedToOrder();
  if ( iPackageDealID || bIsPackageDealBooking ) sMainBuyableType = BUYABLE_TYPE_PACKAGEDEAL;

  const sArrivalDate = booking.sArrivalDate;
  let iArrivalTime = booking.iArrivalTime;

  let iLastPossibleDepartureTime = AppConfig.getIDefaultClosingTime(
    DateTimeUtil.getDateFromString(sArrivalDate)
  );

  let iEntryProductID = null;
  let oBuyable = null;

  if ( sMainBuyableType === BUYABLE_TYPE_NON_PACKAGEDEAL )
  {
    iEntryProductID = booking_select.getCurrentlySelectedActionEntry() || booking_select.getCurrentlySelectedNonActionEntry();

    if ( iEntryProductID )
    {
      oBuyable = products_select.getProductByID(iEntryProductID);

      if ( oBuyable && products_select.isEntryProduct(iEntryProductID) )
      {
        // badenkaart 2 uur
        // voor deze badenkaart booking.sPreferredPartOfTheDay ===  ENTRY_DURATION_2_HOUR en booking.sSelectedEntryType === ENTRY_TYPE_OVERRULE_BADENKAART_KORT
        // in dat geval tonen we alleen de dropdown met starttijd en kunnen we dus altijd de eindtijd dynamisch instellen
        // (er is dus ook een edge case denkbaar dat iemand eerst een eindtijd binnen die 2 uur zet en dan het entreetype switcht NAAR badenkaart kort en die eindtijd dus nog niet goed staat)

        if ( booking.sPreferredPartOfTheDay === ENTRY_DURATION_2_HOUR )
        {
          if ( iArrivalTime + 200 < iLastPossibleDepartureTime )
          {
            iLastPossibleDepartureTime = iArrivalTime + 200;
          }
        }
      }
    }
  }

  // Openingstijden aanpassen voor specifieke datums
  const oSpecialClosingTimes = {
    '24-12-2018': 2200,
    '31-12-2018': 1800
  };

  const iClosingTime = oSpecialClosingTimes[sArrivalDate] || iLastPossibleDepartureTime;

  return Math.min(iLastPossibleDepartureTime, iClosingTime);
}


export function isTodayTheCurrentlySelectedArrivalDate()
{
  const sArrivalDate = booking.sArrivalDate;
  const sDateToday = DateTimeUtil.getTodayAsString();
  return sArrivalDate === sDateToday;
}

export function getCalendarConfigForDate(sRequestedDate)
{
  //console.log('start getCalendarConfigForDate', sRequestedDate);
  if ( typeof sRequestedDate === "object" )
  {
    // day: 19
    // era: "AD"
    // month: 3
    // year: 2025
    // dit is het 2025-3-2 format wat de calendar api call ook gebruikt voor progress.aCalendarDates
    sRequestedDate = sRequestedDate.year + '-' + sRequestedDate.month + '-' + sRequestedDate.day;
  }

  let sRequestedDateYYYYMMDD = DateTimeUtil.convertDateToYYYYdashMMdashDD(sRequestedDate, true);
  let sRequestedDateYYYYMD = DateTimeUtil.convertDateToYYYYdashMMdashDD(sRequestedDate, false);
  let sRequestedDateDDMMYYYY = DateTimeUtil.convertDateToDDdashMMdashYYYY(sRequestedDate, true);
  let sRequestedDateDMYYYY = DateTimeUtil.convertDateToDDdashMMdashYYYY(sRequestedDate, false);

  let oResponse = {
    sDate: sRequestedDate,
    bIsEnabled: true,
    // bIsSpecialDay: false,
    sCustomClass: ''
  };

  // SCENARIO 1: VERLEDEN TIJD
  // Als de dag voor vandaag is dan meteen disabled
  if ( DateTimeUtil.isDateInPast(DateTimeUtil.convertYYYYdashMMdashDDToDDdashMMdashYYYY(sRequestedDate)) )
  {
    oResponse.bIsEnabled = false;
    return oResponse;
  }

  // sRequestedDateYYYYMMDD, sRequestedDateYYYYMD, sRequestedDateDDMMYYYY, sRequestedDateDMYYYY

  // SCENARIO 2: DE DAG ZIT VOL VIA GUESTLIMIT
  // Zorgen dat GuestLimit data wordt verwerkt
  if ( typeof progress.aCalendarDates[sRequestedDate] !== "undefined" )
  {
    //console.log('debug beschikbaarheid', sRequestedDate, progress.aCalendarDates[sRequestedDate]?.DayConfig?.IsAvailable);
    // reminder - de IsAvailable in DayConfig slaat om gastenregulatie (de kalender in het CMS) en niet op of iets ook in Elli beschikbaar is
    if ( progress.aCalendarDates[sRequestedDate]?.DayConfig?.IsAvailable === 0 || progress.aCalendarDates[sRequestedDate]?.DayConfig?.IsAvailable === false )
    {
      //console.log('Deze dag zou niet beschikbaar moeten zijn: ', sRequestedDate);
      oResponse.bIsEnabled = false;
      return oResponse;
    }
  }

  // SCENARIO 3: ACTIEVAGANZA
  // De pagina is geopend om een actie te boeken. Dan is de rest niet relevant
  // aDaysActionIsAvailableFor komt via jsonHmkDaysActionIsAvailableFor en die weer uit $oAction->AllowedDays en dat is iets als ["0","1","2","3","4","5","6"]
  if ( typeof booking.aDaysActionIsAvailableFor === "object" && booking.aDaysActionIsAvailableFor.length > 0 )
  {
    // Als datum in booking.aDaysActionIsAvailableFor staat dan beschikbaar, tenzij hij in disabled staat
    // aDaysActionIsAvailableFor is een array met getallen 0 tot en met 6 waarbij 0 zondag is
    let iRequestedDayOfTheWeek = DateTimeUtil.getWeekDayNumber(sRequestedDate);

    if ( booking.aDaysActionIsAvailableFor.indexOf(iRequestedDayOfTheWeek) > -1 || booking.aDaysActionIsAvailableFor.indexOf("" + iRequestedDayOfTheWeek) > -1 )
    {
      // onze datum is een dag van de week waarop de actie geldig is
      oResponse.sCustomClass = 'hmk-day-action';
      oResponse.bIsEnabled = true;
      return oResponse;
    }
    else
    {
      oResponse.bIsEnabled = false;
      return oResponse;
    }
  }

  // Eenmaal hier is het geen actie

  // sRequestedDateYYYYMMDD, sRequestedDateYYYYMD, sRequestedDateDDMMYYYY, sRequestedDateDMYYYY

  // SCENARIO 4: DE DAG KRIJGT EEN KLEURTJE VANUIT DE APPCONFIG VIA aDatesWithHighlightColor
  if ( AppConfig.aDatesWithHighlightColor && AppConfig.aDatesWithHighlightColor.length > 0 )
  {
    if ( AppConfig.aDatesWithHighlightColor.indexOf(sRequestedDateDDMMYYYY) > -1 )
    {
      oResponse.sCustomClass = 'hmk-day-highlight';
      oResponse.bIsEnabled = true;
      return oResponse;
    }
  }

  // sRequestedDateYYYYMMDD, sRequestedDateYYYYMD, sRequestedDateDDMMYYYY, sRequestedDateDMYYYY

  // SCENARIO 5: DE DAG KRIJGT EEN KLEURTJE VANUIT DE APPCONFIG VIA aDatesWithAlternativeTimes ALS EEN DAG MET AFWIJKENDE PRIJZEN OF TIJDEN?
  const oSpecialDates = {};

  if ( AppConfig.aDatesWithAlternativeTimes && AppConfig.aDatesWithAlternativeTimes.length > 0 )
  {
    if ( AppConfig.aDatesWithAlternativeTimes.indexOf(sRequestedDateDDMMYYYY) > -1 )
    {
      oResponse.sCustomClass = 'hmk-day-special';
      oResponse.bIsEnabled = true;
      return oResponse;
    }
  }

  // sRequestedDateYYYYMMDD, sRequestedDateYYYYMD, sRequestedDateDDMMYYYY, sRequestedDateDMYYYY
  // SCENARIO 6: EEN DAG DIE GEWOON BESCHIKBAAR IS ZONDER VERDERE BIJZONDERHEDEN
  return oResponse;
}